module.exports = __webpack_public_path__ + "media/images/index-hero-badge-pt-9c4e3019d25c51f1e4d64f8b6d7f7ff2.svg";